import React from 'react';
import style from './sectionLink.module.scss';
import { Link, useMatch } from 'react-router-dom';
import cx from 'classnames';
import PhotosIcon from 'icons/photos';
import VectorsIcon from 'icons/vectors';
import IllustrationsIcon from 'icons/illustrations';
import { isDefaultSection, useCurrentCategory } from 'hooks/useCategoryId';
import { CategoryId } from 'store/types';

const icons: { [x: string]: React.ReactNode } = {
  'Фотографии': <PhotosIcon></PhotosIcon>,
  'Векторная графика': <VectorsIcon></VectorsIcon>,
  'Иллюстрации': <IllustrationsIcon></IllustrationsIcon>,
};

export default function SectionLink({
  categoryId,
  to,
  className,
  children,
  onClick,
}: {
  categoryId: CategoryId;
  to: string;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}) {
  let currentName = useMatch('/:name/*')?.params.name || 'photos';
  const currentCategory = useCurrentCategory();

  return (
    <Link
      onClick={onClick}
      className={cx(
        style.link,
        currentCategory?.id === categoryId &&
          currentName &&
          (isDefaultSection(currentName) || currentName === 'search')
          ? style.selected
          : ''
      )}
      to={to}
      color={'inherit'}
    >
      <div className={cx(style.container, className)}>
        {icons[categoryId]}
        {children}
      </div>
    </Link>
  );
}
